import React from 'react';
import {Switch, Route} from 'react-router-dom'
import {publicRoutes} from "../routes";
import {default_language, languages} from "../utils/lang";
import ErrorPage404 from "../pages/ErrorPage404";
import {observer} from "mobx-react-lite";
import {ONLINE_SOLUTION_ROUTE} from "../utils/consts";

const AppRouter = observer(() => {
    return (
        <Switch>
            {publicRoutes.map(({name, path, Component}) =>
                <Route
                    key={path}
                    path={path}
                    component={match => <Component name={name} match={match}/>}
                    exact
                />
            )}
            {publicRoutes.map(({name, path, Component}) =>
                languages.map(({code}) =>
                    default_language !== code && ONLINE_SOLUTION_ROUTE !== path && <Route
                        key={`/${code}${path}`}
                        path={`/${code}${path}`}
                        component={match => <Component name={name} match={match}/>}
                        exact
                    />
                )
            )}
            <Route path="*" component={(props) => (<ErrorPage404 status={404} {...props}/>)} />
        </Switch>
    );
});

export default AppRouter;